import path from 'path';

/**
 * Returns the path to the result.json file (result object that is written to the cache)
 * in the bundle output directory.
 * @param outputPath Path to the bundle output directory.
 */
export function getResultJsonPath(outputPath: string): string {
  return path.join(outputPath, 'result.json');
}
